export default "__VITE_ASSET__DJUW55Mv__"